export const formQKeys = {
  all: () => ["forms"] as const,
  config: (serviceId: string) => ["forms", "config", serviceId] as const,
};
